import { useState, useCallback, useEffect } from "react";
import {
  getTroubleshootReferenceLocations,
  getTroubleshootReferenceCauses,
  getTroubleshootReferenceResolutions,
} from "../../api/ticket";

export function useTroubleshootReferenceLocations() {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLocations = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getTroubleshootReferenceLocations({ ...filter });
      setData(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchLocations();
  }, [fetchLocations]);

  return {
    data,
    meta,
    loading,
    errorMsg,
    fetchLocations,
  };
}

export function useTroubleshootReferenceCauses(locationId) {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCauses = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getTroubleshootReferenceCauses({ ...filter });
      setData(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (locationId) {
      fetchCauses({ location_id: locationId });
    } else {
      setData([]);
    }
  }, [locationId, fetchCauses]);

  return {
    data,
    meta,
    loading,
    errorMsg,
    fetchCauses,
  };
}

export function useTroubleshootReferenceResolutions(causeId) {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchResolutions = useCallback(async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getTroubleshootReferenceResolutions({ ...filter });
      setData(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (causeId) {
      fetchResolutions({ cause_id: causeId });
    } else {
      setData([]);
    }
  }, [causeId, fetchResolutions]);

  return {
    data,
    meta,
    loading,
    errorMsg,
    fetchResolutions,
  };
}
